import React, { useEffect, useRef, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FloatLabel from "../../UiComponents/FloatLabel/FloatLabel";
import {
    GetUserWalletByUserId,
    ReframeEndDateTimeFormat,
    GetUserWallet,
    updateWalletById,
} from "../../Service/_index";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import {
    SearchIcon,
    CloudOffIcon,
    LockPersonIcon,
    AccountBalanceWalletIcon,
    DownloadIcon,
} from "../../Resources/Icons/icons";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { visuallyHidden } from "@mui/utils";
import moment from "moment";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import Drawer from "@mui/material/Drawer";
import PaidTransaction from "./PaidTransaction";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import { CSVLink } from "react-csv";
import { GetPolicyFileById } from "../../Service/_index";
import Loader from "../../UiComponents/Loader/Loader";
import { ToastError } from "../../UiComponents/Toaster/Toast";
import { checkUserType } from "../../Shared/CommonConstant";
import { DatePicker } from "antd";
import { Transition } from "../../UiComponents/Transition/Transition";
import Dialog from "@mui/material/Dialog";
import WalletPassword from "./WalletPassword";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { GetUser } from "../../Service/_index";

const { RangePicker } = DatePicker;

function stableSort(array, comparator) {
    const stabilizedThis = array?.map((el, index) => [el, index]);
    stabilizedThis?.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === "desc"
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

// Wallet Summary Table Headers
const walletSummaryHeaders = [
    {
        id: "userName",
        placeMent: true,
        disablePadding: false,
        label: "User",
    },
    {
        id: "branch",
        placeMent: true,
        disablePadding: false,
        label: "Branch",
    },
    {
        id: "balance",
        placeMent: true,
        disablePadding: false,
        label: "Balance",
    },
    {
        id: "action",
        placeMent: false,
        disablePadding: false,
        label: "Transaction",
    },
];

// Transaction History Table Headers
const transactionHeaders = [
    {
        id: "approveDate",
        placeMent: true,
        disablePadding: false,
        label: "Approve Date",
    },
    {
        id: "policyDate",
        placeMent: true,
        disablePadding: false,
        label: "Policy Date",
    },
    {
        id: "companyName",
        placeMent: true,
        disablePadding: false,
        label: "Company Name",
    },
    {
        id: "policyNumber",
        placeMent: true,
        disablePadding: false,
        label: "Policy Number",
    },
    {
        id: "customerName",
        placeMent: true,
        disablePadding: false,
        label: "Customer Name",
    },
    {
        id: "paymentMode",
        placeMent: true,
        disablePadding: false,
        label: "Payment Mode",
    },
    {
        id: "netPremium",
        placeMent: true,
        disablePadding: false,
        label: "Net Premium",
    },
    {
        id: "totalPremium",
        placeMent: true,
        disablePadding: false,
        label: "Total Premium",
    },
    {
        id: "payableAmount",
        placeMent: true,
        disablePadding: false,
        label: "Payable Amount",
    },
    {
        id: "policyBalance",
        placeMent: true,
        disablePadding: false,
        label: "Policy Balance",
    },
    {
        id: "walletBalance",
        placeMent: true,
        disablePadding: false,
        label: "Wallet Balance",
    },
];

const summaryHeaders = [
    {
        id: "transactionDate",
        placeMent: true,
        disablePadding: false,
        label: "Transaction Date",
    },
    {
        id: "userName",
        placeMent: true,
        disablePadding: false,
        label: "User",
    },
    {
        id: "orderId",
        placeMent: true,
        disablePadding: false,
        label: "Order ID",
    },
    {
        id: "status",
        placeMent: true,
        disablePadding: false,
        label: "Status",
    },
    {
        id: "amount",
        placeMent: true,
        disablePadding: false,
        label: "Amount",
    },
    {
        id: "action",
        placeMent: false,
        disablePadding: false,
        label: "Action",
    },
];

function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort, headCells } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells?.map((headCell) => (
                    <TableCell
                        className="TableHeader"
                        key={headCell.id}
                        align={headCell.placeMent ? "left" : "center"}
                        padding={headCell.disablePadding ? "none" : "normal"}
                        sortDirection={orderBy === headCell.id ? order : false}
                        sx={{ fontSize: "16px", fontWeight: 600 }}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : "asc"}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === "desc" ? "sorted descending" : "sorted ascending"}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    headCells: PropTypes.array.isRequired,
};

const MotorWallet = () => {
    const UserType = sessionStorage.getItem("userType");
    let currentDate = new Date();
    let last7Days = new Date();
    last7Days.setDate(last7Days.getDate() - 7);

    // State for wallet summary
    const [walletSummary, setWalletSummary] = useState([]);
    const [totalWallet, setTotalWallet] = useState([]);

    // State for transaction history
    const [transactionData, setTransactionData] = useState([]);
    const [walletAmt, setWalletAmt] = useState(0);
    const [selectedWallet, setSelectedWallet] = useState(null);

    // Common states
    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState("id");
    const [summaryPage, setSummaryPage] = useState(0);
    const [transactionPage, setTransactionPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openLoader, setOpenLoader] = useState(false);
    const [selectedStartDate, setSelectedStartDate] = useState(dayjs(last7Days));
    const [selectedEndDate, setSelectedEndDate] = useState(dayjs(currentDate));
    const [isAllow, setIsAllow] = useState({});
    const [filterType, setFilterType] = useState(
        UserType === "user" ? "All" : ""
    );
    const [selectedUser, setSelecteduser] = useState("");
    const [userDetails, setUserDetails] = useState([]);
    const [openPaidTransaction, setOpenPaidTransaction] = useState(false);
    const [functionType, setFunctionType] = useState();
    const [openWalletPwdDrawer, setOpenWalletPwdDrawer] = useState(false);
    const [openTransactionDrawer, setOpenTransactionDrawer] = useState(false);
    const [viewType, setViewType] = useState("statement");
    const [walletTransactionData, setWalletTransactionData] = useState([]);
    const [filteredSummaryData, setFilteredSummaryData] = useState([]);
    const [topupPage, setTopupPage] = useState(0);
    const [topupRowsPerPage, setTopupRowsPerPage] = useState(5);
    const [formType, setFormType] = useState("add");
    const [walletPassword, setWalletPassword] = useState("");
    const [displayResetPassword, setDisplayResetPassword] = useState(false);

    const [summaryFilter, setSummaryFilter] = useState({
        fn: (items) => {
            return items;
        },
    });

    const [transactionFilter, setTransactionFilter] = useState({
        fn: (items) => {
            return items;
        },
    });

    const visibleWalletRows = React.useMemo(
        () =>
            stableSort(summaryFilter.fn(walletSummary), getComparator(order, orderBy))?.slice(
                summaryPage * rowsPerPage,
                summaryPage * rowsPerPage + rowsPerPage
            ),
        [order, orderBy, summaryPage, rowsPerPage, summaryFilter, walletSummary]
    );

    const visibleTransactionRows = React.useMemo(
        () =>
            stableSort(
                transactionFilter.fn(transactionData),
                getComparator(order, orderBy)
            )?.slice(transactionPage * rowsPerPage, transactionPage * rowsPerPage + rowsPerPage),
        [order, orderBy, transactionPage, rowsPerPage, transactionFilter, transactionData]
    );

    const visibleTopupRows = React.useMemo(
        () =>
            stableSort(
                filteredSummaryData,
                getComparator(order, orderBy)
            )?.slice(topupPage * topupRowsPerPage, topupPage * topupRowsPerPage + topupRowsPerPage),
        [order, orderBy, topupPage, topupRowsPerPage, filteredSummaryData]
    );

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };

    const handleSummaryPageChange = (event, newPage) => {
        setSummaryPage(newPage);
    };

    const handleTransactionPageChange = (event, newPage) => {
        setTransactionPage(newPage);
    };

    const handleTopupPageChange = (event, newPage) => {
        setTopupPage(newPage);
    };

    const handleChangeTopupRowsPerPage = (event) => {
        setTopupRowsPerPage(parseInt(event.target.value, 10));
        setTopupPage(0);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setSummaryPage(0);
        setTransactionPage(0);
    };

    const GetUserDetails = () => {
        const bodyData = {
            requesttype: "TABLE",
            isAscending: true,
        };
        GetUser(bodyData)
            .then((res) => {
                const FilteredData = res.data
                    .map((e) => {
                        if (e.userType.includes("user")) {
                            return {
                                ...e,
                                label: e.name + " - " + e.mobileNumber + " - " + e.email,
                                value: e?._id,
                            };
                        } else {
                            return null;
                        }
                    })
                    .filter(Boolean);
                setUserDetails(FilteredData);
            })
            .catch((err) => ToastError("Network Error"));
    };

    useEffect(() => {
        GetUserDetails();
        const renderData = checkUserType(UserType);
        setIsAllow(renderData);
        if (renderData.isUser) {
            GetWalletSummary();
        }
    }, [UserType]);

    const calculateSum = (arr) => {
        return arr?.reduce((total, current) => {
            return Number(total) + Number(current);
        }, 0);
    };

    const walletPasswordAction = () => {
        setFormType("add");
        setOpenWalletPwdDrawer(true);
    };

    const closeDialog = () => {
        setOpenWalletPwdDrawer(false);
    };

    const onWalletSearch = (e) => {
        let target = e.target;
        setSummaryFilter({
            fn: (items) => {
                if (target.value == "") return items;
                else
                    return items.filter((el) =>
                        `${el?.userName},${el?.branch} , ${el?.walletBalance}`
                            .toLowerCase()
                            .includes(target.value.toLowerCase())
                    );
            },
        });
        setSummaryPage(0);
    };

    const onTransactionSearch = (e) => {
        let target = e.target;
        setTransactionFilter({
            fn: (items) => {
                if (target.value == "") return items;
                else
                    return items.filter((el) =>
                        `${el?.policyNumber},${el?.companyName},${el.customerName},${el?.netPremium},${el?.paymentMode},${el?.totalPremium},${el?.payableAmount},${el?.policyBalance},${el?.walletBalance}`
                            .toLowerCase()
                            .includes(target.value.toLowerCase())
                    );
            },
        });
    };

    const onTopupSearch = (e) => {
        let target = e.target;
        if (target.value === "") {
            setFilteredSummaryData(walletTransactionData);
        } else {
            const filtered = walletTransactionData.filter((el) =>
                `${el?.userName},${el?.orderId},${el?.status},${el?.amount}`
                    .toLowerCase()
                    .includes(target.value.toLowerCase())
            );
            setFilteredSummaryData(filtered);
        }
        setTopupPage(0);
    };

    const GetWalletSummary = async () => {
        setOpenLoader(true);
        let endDate = null;
        if (selectedEndDate) {
            const eDate = await ReframeEndDateTimeFormat(selectedEndDate);
            endDate = eDate;
        }
        GetUserWallet(filterType, {
            userId: selectedUser,
            startDate: selectedStartDate,
            endDate: endDate,
        })
            .then((res) => {
                setOpenLoader(false);
                const renderData = checkUserType(UserType);
                if (renderData.isUser) {
                    setWalletSummary(res.data);
                    setWalletPassword(res?.data[0]?.walletPassword ?? "");
                    // Auto-select first wallet for user
                    if (res.data && res.data.length > 0) {
                        ViewTransactionHistory(res.data[0]);
                    }
                } else {
                    setWalletSummary(
                        res.data.filter((e) => {
                            if (!selectedUser)
                                return e?.walletBalance > 1 || e?.walletBalance < 0;
                            else return e;
                        })
                    );
                }
                const totalWalletValues = res.data.map((e) => e?.walletBalance);
                setTotalWallet(totalWalletValues);
                setSummaryPage(0);
            })
            .catch((err) => {
                setOpenLoader(false);
            });
    };

    const GetUserWalletDetails = async (userId) => {
        console.log("GetUserWalletDetails called with userId:", userId);
        setOpenLoader(true);
        let customEndDate = null;
        if (selectedEndDate) {
            customEndDate = await ReframeEndDateTimeFormat(selectedEndDate);
        }

        GetUserWalletByUserId(userId, {
            selectedStartDate,
            customEndDate,
        })
            .then((res) => {
                console.log("Transaction data received:", res.data);
                const data = res.data;
                if (Array.isArray(data)) {
                    setTransactionData(data);
                    setWalletTransactionData([]);
                    setWalletAmt(data.length ? data[0]?.walletBalance : 0);
                } else {
                    setTransactionData(data?.policyData || []);
                    setWalletTransactionData(data?.walletTransactions || []);
                    setFilteredSummaryData(data?.walletTransactions || []);
                    setWalletAmt(data?.walletBalance || 0);
                }
            })
            .catch((err) => {
                console.error("Error fetching wallet details:", err);
                ToastError("Failed to load transaction history");
            })
            .finally(() => {
                setOpenLoader(false);
            });
    };

    const FilterOptions = [
        {
            label: "Daily Payout",
            value: "Daily",
        },
        {
            label: "Weekly Payout",
            value: "Weekly",
        },
        {
            label: "Monthly Payout",
            value: "Monthly",
        },
        {
            label: "All Payout",
            value: "All",
        },
    ];

    const ViewTransactionHistory = (walletData) => {
        if (walletData) {
            if (isAllow.isUser && walletData.walletPassword) {
                setSelectedWallet(walletData);
                setFormType("check");
                setOpenWalletPwdDrawer(true);
                setViewType("statement");
            } else {
                setSelectedWallet(walletData);
                setViewType("statement");
                setOpenTransactionDrawer(true);
                GetUserWalletDetails(walletData.userId);
                setDisplayResetPassword(walletData.walletPassword ? true : false);
            }
        }
    };

    const ViewSummary = (walletData) => {
        if (walletData) {
            if (isAllow.isUser && walletData.walletPassword) {
                setSelectedWallet(walletData);
                setFormType("check");
                setOpenWalletPwdDrawer(true);
                setViewType("summary");
            } else {
                setSelectedWallet(walletData);
                setViewType("summary");
                setOpenTransactionDrawer(true);
                GetUserWalletDetails(walletData.userId);
                setDisplayResetPassword(walletData.walletPassword ? true : false);
            }
        }
    };

    const closeTransactionDrawer = () => {
        setOpenTransactionDrawer(false);
    };

    const SearchFunction = () => {
        if (filterType) {
            GetWalletSummary();
        } else {
            ToastError("Choose the filter type");
        }
    };

    const PaidFunction = () => {
        setOpenPaidTransaction(true);
        setFunctionType("Paid");
    };

    const ReceivedFunction = () => {
        setOpenPaidTransaction(true);
        setFunctionType("Received");
    };

    const base64toBlob = (base64Data, contentType) => {
        contentType = contentType || "";
        var sliceSize = 1024;
        var byteCharacters = atob(base64Data);
        var bytesLength = byteCharacters.length;
        var slicesCount = Math.ceil(bytesLength / sliceSize);
        var byteArrays = new Array(slicesCount);

        for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            var begin = sliceIndex * sliceSize;
            var end = Math.min(begin + sliceSize, bytesLength);

            var bytes = new Array(end - begin);
            for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
                bytes[i] = byteCharacters[offset].charCodeAt(0);
            }
            byteArrays[sliceIndex] = new Uint8Array(bytes);
        }
        return new Blob(byteArrays, { type: contentType });
    };

    const OpenPolicyFile = (row) => {
        setOpenLoader(true);
        GetPolicyFileById(row?.policyId)
            .then((res) => {
                const pdfUrl = res.data.policyFile.downloadURL;
                return pdfUrl;
            })
            .then((pdfUrl) => {
                const blobData = base64toBlob(pdfUrl, "application/pdf");
                const blobUrl = URL.createObjectURL(blobData);
                setOpenLoader(false);
                const pdfWindow = window.open("", "_blank");
                pdfWindow?.document?.write(
                    `<embed src="${blobUrl}" width="100%" height="100%" />`
                );
            })
            .catch((err) => {
                ToastError("Something went wrong");
                setOpenLoader(false);
            });
    };

    const walletSummaryCSV = {
        filename: "Motor Wallet Summary",
        headers: [
            { label: "User Name", key: "userName" },
            { label: "Branch", key: "branch" },
            { label: "Wallet Balance", key: "walletBalance" },
        ],
        data: walletSummary,
    };

    const transactionCSV = {
        filename: "Motor Wallet Transactions",
        headers: [
            { label: "Approve Date", key: "approvedDate" },
            { label: "Policy Date", key: "policyDate" },
            { label: "Company Name", key: "companyName" },
            { label: "Policy Number", key: "policyNumber" },
            { label: "Customer Name", key: "customerName" },
            { label: "Payment Mode", key: "paymentMode" },
            { label: "Net Premium", key: "netPremium" },
            { label: "Total Premium", key: "totalPremium" },
            { label: "Payable Amount", key: "payableAmount" },
            { label: "Policy Balance", key: "policyBalance" },
            { label: "Wallet Balance", key: "walletBalance" },
        ],
        data: transactionData,
    };

    const resetPasswordAction = () => {
        setOpenWalletPwdDrawer(true);
    };

    const closePasswordDialog = () => {
        setOpenWalletPwdDrawer(false);
    };

    return (
        <>
            {/* Filter Section */}
            <Grid
                container
                spacing={2}
                sx={{ padding: "10px 10px 0 10px" }}
                className="Master_Header_Container"
            >
                <Grid
                    item
                    xs={12}
                    sm={3}
                    sx={{ display: isAllow.isUser ? "none" : "block" }}
                >
                    <FloatLabel label="Filter Type" value={filterType} important="*">
                        <Autocomplete
                            className="AutoComplete_InputBox"
                            options={FilterOptions}
                            onChange={(e, v) => {
                                setFilterType(v ? v?.value : null);
                            }}
                            renderInput={(params) => <TextField {...params} />}
                            isOptionEqualToValue={(option, value) =>
                                option.value === value.value
                            }
                        />
                    </FloatLabel>
                </Grid>
                <Grid
                    item
                    sm={3}
                    xs={12}
                    sx={{ display: isAllow.isUser ? "none" : "block" }}
                >
                    <FloatLabel label="Select User" value={selectedUser}>
                        <Autocomplete
                            className="AutoComplete_InputBox"
                            disablePortal
                            id="combo-box-demo"
                            options={userDetails}
                            onChange={(e, v) => setSelecteduser(v?._id)}
                            renderInput={(params) => <TextField {...params} />}
                            renderOption={(props, option) => (
                                <li {...props} key={option._id}>
                                    {option.name +
                                        " - " +
                                        option.mobileNumber +
                                        " - " +
                                        option.email}
                                </li>
                            )}
                        />
                    </FloatLabel>
                </Grid>

                <Grid item sm={3} xs={12}>
                    <FloatLabel label="Start date & End Date" value="react">
                        <RangePicker
                            placement="bottomLeft"
                            className="textField w-100"
                            style={{ borderRadius: "0px" }}
                            value={[selectedStartDate, selectedEndDate]}
                            onChange={(e) => {
                                setSelectedStartDate(e ? dayjs(e[0]?.$d) : null);
                                setSelectedEndDate(e ? dayjs(e[1]?.$d) : null);
                            }}
                            format="DD/MM/YYYY"
                        />
                    </FloatLabel>
                </Grid>

                <Grid
                    item
                    sm={3}
                    xs={12}
                    sx={{ display: "flex", marginBottom: "8px" }}
                    gap={2}
                >
                    <Button
                        className="Master_Header_create_Button"
                        sx={{ width: { xs: "100%", sm: "50%" } }}
                        onClick={SearchFunction}
                    >
                        Search
                    </Button>
                </Grid>
                <Grid
                    item
                    sm={3}
                    xs={12}
                    sx={{ display: isAllow.isUser ? "block" : "none" }}
                >
                    <Button
                        className="Master_Header_create_Button"
                        sx={{
                            width: { xs: "100%", sm: "50%" },
                            display: walletPassword ? "none" : "flex",
                        }}
                        onClick={walletPasswordAction}
                        startIcon={<LockPersonIcon />}
                    >
                        Wallet Password
                    </Button>
                </Grid>
                <Grid
                    item
                    sm={3}
                    xs={12}
                    sx={{ display: isAllow.isUser ? "block" : "none" }}
                />
            </Grid>

            {/* Wallet Summary Section */}
            <Box sx={{ flexGrow: 1 }} mt={4}>
                <Grid container className="Master_Header_Container" spacing={2}>
                    <Grid item xs={12} sm={3}>
                        <Typography className="Master_Header_Heading">
                            Motor Wallet Summary
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={3.5}></Grid>
                    <Grid item xs={12} sm={2}>
                        <Button
                            className="Master_Header_create_Button w-100"
                            startIcon={<AccountBalanceWalletIcon />}
                        >
                            Total Wallet = {calculateSum(totalWallet?.map((value) => value))}
                        </Button>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={2}
                        sx={{ display: isAllow.isUser ? "none" : "block" }}
                    >
                        <Input
                            focused="false"
                            className="w-100 Master_Header_Input"
                            id="standard-adornment-password"
                            onChange={onWalletSearch}
                            disableUnderline={true}
                            placeholder="Search"
                            startAdornment={
                                <InputAdornment position="start">
                                    <IconButton aria-label="toggle password visibility">
                                        <SearchIcon />
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={1.5}
                        className="d-flex justify-content-end"
                        sx={{ display: isAllow.isUser ? "none !important" : "block" }}
                    >
                        <Button
                            className="Master_Header_create_Button w-100"
                            endIcon={<DownloadIcon />}
                            sx={{ width: { xs: "100%", sm: "fit-content" } }}
                        >
                            <CSVLink className="Download_Excel_Button" {...walletSummaryCSV}>
                                Download Excel
                            </CSVLink>
                        </Button>
                    </Grid>
                </Grid>
            </Box>
            <div className="d-flex PageContainer">
                <Paper className={"container-fluid TableBox "}>
                    <TableContainer className="TableContainer">
                        <Table
                            aria-labelledby="tableTitle"
                            size="medium"
                            stickyHeader
                            aria-label="sticky table"
                            sx={{ minWidth: 750 }}
                        >
                            <EnhancedTableHead
                                order={order}
                                orderBy={orderBy}
                                onRequestSort={handleRequestSort}
                                headCells={walletSummaryHeaders}
                            />
                            <TableBody>
                                {visibleWalletRows?.map((row, index) => {
                                    return (
                                        <TableRow
                                            hover
                                            tabIndex={-1}
                                            key={row.userId}
                                            sx={{ cursor: "pointer" }}
                                        >
                                            <TableCell align="left">{row?.userName}</TableCell>
                                            <TableCell align="left">{row?.branch}</TableCell>
                                            <TableCell align="left">{row?.walletBalance}</TableCell>
                                            <TableCell align="center">
                                                <Box
                                                    className="ActionIcons d-flex"
                                                    sx={{ justifyContent: "center", gap: 1 }}
                                                >
                                                    <Button
                                                        variant="outlined"
                                                        color="success"
                                                        sx={{
                                                            width: {
                                                                xs: "45%",
                                                                sm: "45%",
                                                            },
                                                            backgroundColor: "green",
                                                            fontSize: "12px",
                                                            color: "white",
                                                            padding: "10px",
                                                            textTransform: "capitalize",
                                                            "&:hover": {
                                                                color: "green",
                                                            },
                                                        }}
                                                        onClick={() => ViewTransactionHistory(row)}
                                                    >
                                                        Statement
                                                    </Button>
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        sx={{
                                                            width: {
                                                                xs: "45%",
                                                                sm: "45%",
                                                            },
                                                            backgroundColor: "#1976d2",
                                                            fontSize: "12px",
                                                            color: "white",
                                                            padding: "10px",
                                                            textTransform: "capitalize",
                                                            "&:hover": {
                                                                color: "#1976d2",
                                                            },
                                                        }}
                                                        onClick={() => ViewSummary(row)}
                                                    >
                                                        Summary
                                                    </Button>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                                {visibleWalletRows?.length < 1 ? (
                                    <TableRow>
                                        <TableCell
                                            colSpan={12}
                                            sx={{ textAlign: "center", border: "none" }}
                                        >
                                            <CloudOffIcon
                                                sx={{ fontSize: "100px", color: "#c5c3c3" }}
                                            />
                                            <br />
                                            <Typography sx={{ color: "#c5c3c3" }}>
                                                Oops! No Data Found
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ) : null}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={summaryFilter.fn(walletSummary).length || 0}
                        rowsPerPage={rowsPerPage}
                        page={summaryPage}
                        onPageChange={handleSummaryPageChange}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>
            </div>

            {/* Transaction History Drawer */}
            <Drawer
                open={openTransactionDrawer}
                sx={{
                    zIndex: 100,
                }}
                anchor="right"
                PaperProps={{
                    sx: { width: { xs: "100%", sm: "100%" } },
                }}
            >
                {openTransactionDrawer && selectedWallet ? (
                    <>
                        {/* Drawer Header */}
                        <Box sx={{ flexGrow: 1 }} mt={2}>
                            <Grid container className="Master_Header_Container" spacing={2} sx={{ padding: '0 20px' }}>
                                <Grid item xs={12} sm={10}>
                                    <Typography className="Master_Header_Heading">
                                        {viewType === 'summary' ? "Transaction History" : `Transaction of ${selectedWallet?.userName}`}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <IconButton onClick={closeTransactionDrawer}>
                                        <CloseIcon />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </Box>

                        {viewType === 'summary' ? (
                            <>
                                {/* Summary Filters (Grinar Style) */}
                                <Box sx={{ flexGrow: 1 }} mt={2}>
                                    <Grid container className="Master_Header_Container" spacing={2} sx={{ padding: '0 20px', alignItems: 'center' }}>
                                        <Grid item xs={12} sm={2}>
                                            <Box sx={{ p: 1, bgcolor: '#f0f4f8', borderRadius: 2, textAlign: 'center', border: '1px solid #e1e4e8' }}>
                                                <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#1976d2' }}>
                                                    {walletAmt}
                                                </Typography>
                                                <Typography variant="caption" sx={{ color: '#555' }}>
                                                    Wallet Balance
                                                </Typography>
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} sm={2} />

                                        <Grid item xs={12} sm={3}>
                                            <FloatLabel label="Filter Status" value={null}>
                                                <Autocomplete
                                                    options={[{ label: "Success", value: "SUCCESS" }, { label: "Failure", value: "FAILURE" }]}
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </FloatLabel>
                                        </Grid>

                                        <Grid item xs={12} sm={2}>
                                            <Button
                                                className="Common_Button w-100"
                                                onClick={PaidFunction}
                                                sx={{ height: '40px' }}
                                            >
                                                Wallet Topup
                                            </Button>
                                        </Grid>

                                        <Grid item xs={12} sm={3}>
                                            <Input
                                                focused="false"
                                                className="w-100 Master_Header_Input"
                                                onChange={onTopupSearch}
                                                disableUnderline={true}
                                                placeholder="Search Topups"
                                                startAdornment={
                                                    <InputAdornment position="start">
                                                        <IconButton>
                                                            <SearchIcon />
                                                        </IconButton>
                                                    </InputAdornment>
                                                }
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>

                                {/* Summary Table */}
                                <div className="d-flex PageContainer" style={{ padding: '0 20px' }}>
                                    <Paper className={"container-fluid TableBox "}>
                                        <TableContainer className="TableContainer">
                                            <Table stickyHeader sx={{ minWidth: 750 }}>
                                                <EnhancedTableHead
                                                    order={order}
                                                    orderBy={orderBy}
                                                    onRequestSort={handleRequestSort}
                                                    headCells={summaryHeaders}
                                                />
                                                <TableBody>
                                                    {visibleTopupRows?.map((row, index) => (
                                                        <TableRow hover tabIndex={-1} key={index}>
                                                            <TableCell>{moment(row?.transactionDate).format("DD-MM-YYYY LT")}</TableCell>
                                                            <TableCell>{row?.userName}</TableCell>
                                                            <TableCell>{row?.orderId || row?.policyNumber}</TableCell>
                                                            <TableCell sx={{ color: row?.status === 'SUCCESS' ? 'green' : row?.status === 'FAILURE' ? 'red' : 'orange', fontWeight: 'bold' }}>
                                                                {row?.status}
                                                            </TableCell>
                                                            <TableCell>{row?.amount}</TableCell>
                                                            <TableCell>
                                                                <Button
                                                                    variant="contained"
                                                                    color="error"
                                                                    size="small"
                                                                    // onClick={() => revertTransaction(row)}
                                                                    sx={{ textTransform: 'none' }}
                                                                >
                                                                    Revert
                                                                </Button>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                    {visibleTopupRows?.length < 1 && (
                                                        <TableRow>
                                                            <TableCell colSpan={6} sx={{ textAlign: "center", border: "none" }}>
                                                                <CloudOffIcon sx={{ fontSize: "100px", color: "#c5c3c3" }} />
                                                                <br />
                                                                <Typography sx={{ color: "#c5c3c3" }}>Oops! No Data Found</Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                        <TablePagination
                                            rowsPerPageOptions={[5, 10, 25]}
                                            component="div"
                                            count={filteredSummaryData.length}
                                            rowsPerPage={topupRowsPerPage}
                                            page={topupPage}
                                            onPageChange={handleTopupPageChange}
                                            onRowsPerPageChange={handleChangeTopupRowsPerPage}
                                        />
                                    </Paper>
                                </div>
                            </>
                        ) : (
                            <>
                                {/* Transaction Content (Statement) */}
                                <Box sx={{ flexGrow: 1 }} mt={2}>
                                    <Grid container className="Master_Header_Container" spacing={2} sx={{ padding: '0 20px' }}>
                                        <Grid item xs={12} sm={2}>
                                            <Button className="Master_Header_create_Button w-100">
                                                Wallet Balance = {walletAmt}
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} sm={5.5}></Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={2}
                                            sx={{ display: isAllow?.isUser ? "none" : "flex" }}
                                            gap={1}
                                        >
                                            <Button
                                                className="Master_Header_create_Button"
                                                onClick={PaidFunction}
                                                sx={{ width: "50%" }}
                                            >
                                                Paid
                                            </Button>
                                            <Button
                                                className="Master_Header_create_Button"
                                                onClick={ReceivedFunction}
                                                sx={{ width: "50%" }}
                                            >
                                                Received
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} sm={2}>
                                            <Input
                                                focused="false"
                                                className="w-100 Master_Header_Input"
                                                id="standard-adornment-password-transaction"
                                                onChange={onTransactionSearch}
                                                disableUnderline={true}
                                                placeholder="Search"
                                                startAdornment={
                                                    <InputAdornment position="start">
                                                        <IconButton aria-label="toggle password visibility">
                                                            <SearchIcon />
                                                        </IconButton>
                                                    </InputAdornment>
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={0.5} className="d-flex justify-content-end">
                                            <Button
                                                className="Master_Header_create_Button w-100"
                                                endIcon={<DownloadIcon />}
                                                sx={{ width: { xs: "100%", sm: "fit-content" } }}
                                            >
                                                <CSVLink className="Download_Excel_Button" {...transactionCSV}>
                                                    Excel
                                                </CSVLink>
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                                {/* Transaction Table (Statement) */}
                                <div className="d-flex PageContainer" style={{ padding: '0 20px' }}>
                                    <Paper className={"container-fluid TableBox "}>
                                        <TableContainer className="TableContainer">
                                            <Table
                                                aria-labelledby="tableTitle"
                                                size="medium"
                                                stickyHeader
                                                aria-label="sticky table"
                                                sx={{ minWidth: 750 }}
                                            >
                                                <EnhancedTableHead
                                                    order={order}
                                                    orderBy={orderBy}
                                                    onRequestSort={handleRequestSort}
                                                    headCells={transactionHeaders}
                                                />
                                                <TableBody>
                                                    {visibleTransactionRows?.map((row, index) => {
                                                        return (
                                                            <TableRow
                                                                hover
                                                                tabIndex={-1}
                                                                key={index}
                                                                sx={{ cursor: "pointer" }}
                                                            >
                                                                <TableCell component="th" scope="row" padding="normal">
                                                                    {moment(row?.approvedDate).format("DD-MM-YYYY LT")}
                                                                </TableCell>
                                                                <TableCell component="th" scope="row" padding="normal">
                                                                    {moment(row?.policyDate).format("DD-MM-YYYY")}
                                                                </TableCell>
                                                                <TableCell align="left">{row?.companyName}</TableCell>
                                                                <TableCell align="left" sx={{ color: "blue" }}>
                                                                    <label
                                                                        onClick={() => OpenPolicyFile(row)}
                                                                        style={{
                                                                            textDecoration: "underline",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        {row?.policyNumber}
                                                                    </label>
                                                                </TableCell>
                                                                <TableCell align="left">{row?.customerName}</TableCell>
                                                                <TableCell align="left">{row?.paymentMode}</TableCell>
                                                                <TableCell align="left">{row?.netPremium}</TableCell>
                                                                <TableCell align="left">{row?.totalPremium}</TableCell>
                                                                <TableCell align="left">{row?.payableAmount}</TableCell>
                                                                <TableCell align="left">{row?.policyBalance}</TableCell>
                                                                <TableCell align="left">{row?.walletBalance}</TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                    {visibleTransactionRows?.length < 1 ? (
                                                        <TableRow>
                                                            <TableCell
                                                                colSpan={12}
                                                                sx={{ textAlign: "center", border: "none" }}
                                                            >
                                                                <CloudOffIcon
                                                                    sx={{ fontSize: "100px", color: "#c5c3c3" }}
                                                                />
                                                                <br />
                                                                <Typography sx={{ color: "#c5c3c3" }}>
                                                                    Oops! No Data Found
                                                                </Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    ) : null}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                        <TablePagination
                                            rowsPerPageOptions={[5, 10, 25]}
                                            component="div"
                                            count={transactionFilter.fn(transactionData).length || 0}
                                            rowsPerPage={rowsPerPage}
                                            page={transactionPage}
                                            onPageChange={handleTransactionPageChange}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                        />
                                    </Paper>
                                </div>
                            </>
                        )}
                    </>
                ) : null}
            </Drawer>

            <Loader open={openLoader} />

            {/* Paid/Received Transaction Drawer */}
            <Drawer
                open={openPaidTransaction}
                sx={{
                    zIndex: 101,
                }}
                anchor="right"
                PaperProps={{
                    sx: { width: { xs: "100%", sm: "25%" } },
                }}
            >
                {openPaidTransaction ? (
                    <PaidTransaction
                        setOpenPaidTransaction={setOpenPaidTransaction}
                        selectedData={selectedWallet}
                        PaidUserName={selectedWallet?.userName}
                        GetUserWalletDetails={() =>
                            GetUserWalletDetails(selectedWallet.userId)
                        }
                        functionType={functionType}
                        GetData={GetWalletSummary}
                        setDrawerWidth={() => { }}
                    />
                ) : null}
            </Drawer>

            {/* Wallet Password Dialog */}
            <Dialog
                open={openWalletPwdDrawer}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
                PaperProps={{
                    style: {
                        maxWidth: "30%",
                    },
                }}
            >
                {openWalletPwdDrawer ? (
                    <WalletPassword
                        setOpenDrawer={setOpenWalletPwdDrawer}
                        formType={formType}
                        selectedData={selectedWallet}
                        GetData={GetWalletSummary}
                        title={
                            formType == "add"
                                ? "Create"
                                : formType == "check"
                                    ? "Enter"
                                    : "Edit"
                        }
                        closeDialog={() => {
                            setOpenWalletPwdDrawer(false);
                            if (formType === "check" && selectedWallet) {
                                setOpenTransactionDrawer(true);
                                GetUserWalletDetails(selectedWallet.userId);
                                setDisplayResetPassword(
                                    selectedWallet.walletPassword ? true : false
                                );
                            }
                        }}
                    />
                ) : null}
            </Dialog>
        </>
    );
};

export default MotorWallet;
